import { addToast } from 'modules/messageSystem/actions/addToast';
import { getConversationParticipantName } from 'modules/appointmentInfo/selectors/currentAppointment';
import { DECLINED } from 'modules/common/constants/conversationStatuses';

import { stopConsultationWithNoPatientAnswer } from '../stopConsultation';

export const onDecline = () => (dispatch, getState) => {
  const name = getConversationParticipantName(getState());

  dispatch(stopConsultationWithNoPatientAnswer(DECLINED))
    .then(() => {
      dispatch(addToast('failure', 'clinician-declined-toast', {
        id: 'const.connection.clinicianDeclinedCall',
        defaultMessage: '** {name} declined your call. Please try again later.',
        values: { name },
      }, false, null, true, false, null, 6000, 'video'));
    });
};
